// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__36uJ5","paramInput":"JobSimulator_paramInput__16Wg4","input":"JobSimulator_input__3wrfL"};